import(/* webpackMode: "eager", webpackExports: ["SWRProvider"] */ "/home/runner/work/Teelor/Teelor/app/providers/SWRProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/home/runner/work/Teelor/Teelor/components/analytics/Google.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Teelor/Teelor/components/layout/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Teelor/Teelor/components/layout/navigation/ConditionalHamburger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Teelor/Teelor/components/layout/navigation/mobile/MobileNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Teelor/Teelor/components/layout/navigation/sidebar/DesktopSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuProvider"] */ "/home/runner/work/Teelor/Teelor/context/MenuContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationProvider"] */ "/home/runner/work/Teelor/Teelor/context/TranslationContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/android-chrome-192x192.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/android-chrome-512x512.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-114x114.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-120x120.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-144x144.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-152x152.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-167x167.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-180x180.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-57x57.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-60x60.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-72x72.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/apple-touch-icon-76x76.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/favicon-128x128.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/favicon-16x16.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/favicon-196x196.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/favicon-32x32.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/favicon-96x96.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/icon.ico");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/mstile-144x144.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/mstile-150x150.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/mstile-310x150.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/mstile-310x310.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/mstile-70x70.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/public/favicon/safari-pinned-tab.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/styles/globals.css");
